import { render, staticRenderFns } from "./GroupTitle.vue?vue&type=template&id=2bb1144e&scoped=true"
import script from "./GroupTitle.vue?vue&type=script&lang=js"
export * from "./GroupTitle.vue?vue&type=script&lang=js"
import style0 from "./GroupTitle.vue?vue&type=style&index=0&id=2bb1144e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb1144e",
  null
  
)

export default component.exports